import Alpine from "alpinejs";

const fetchNotificationsFromServer = async (server_url) => {
    const response = await fetch(server_url, {
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
        },
    })
    return response.json();
};

const getNotifications = async () => {
    const response = await fetchNotificationsFromServer(ref_app_notifications_server_url);
    console.log({response});
    if (!response.success ?? false) {
        console.log("Could not get notitications from server");
        return;
    }

    localStorage.setItem('notifications', JSON.stringify(response.notifications));
}

getNotifications().then(() => {
    Alpine.store('notifications').updateNotifications();
});
